/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PerfEnergyStationKpiPagedList } from '../../models/perf-energy-station-kpi-paged-list';
import { SortDirection } from '../../models/sort-direction';

export interface GetPerfEnergyKpIsGroupByStation$Any$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * STATION_NAME : the station's name
 *   * CONSUMPTION_ELECTRICITY_KWH: Consommation électrique en kWh
 *   * ACTIVE_POWER: en W
 *   * REACTIVE_POWER: en VAr
 *   * GAS_PURCHASED_NM3: Gaz acheté en Nm3
 *   * GAS_PURCHASED_KWH: Gaz acheté en kWh
 *   * GAS_SOLD_NM3: Gaz vendu en Nm3
 *   * GAS_SOLD_VARIATION: Variation Gaz vendu
 *   * RATIO_CONSUMPTION_KWH_GAS_PURCHASED_NM3: Division entre Consommation électrique en kWh / Gaz acheté en Nm3
 *   * RATIO_GAS_SOLD_PERCENT: Ration entre le gaz acheté en kWh et le gaz vendu en %
 *   * SUB_PURCHASED_SOLD_NM3: Différence entre le GAS_PURCHASED_NM3 et le GAS_SOLD_NM3
 *   * PTA_MIN: PTA Min
 *   * PTA_MAX: PTA Max
 *   * PTA_AVG: PTA Moyenne
 *   * COS_PHI_AVG: Cos phi moyen
 */
  sortFieldName?: 'STATION_NAME' | 'CONSUMPTION_ELECTRICITY_KWH' | 'ACTIVE_POWER' | 'REACTIVE_POWER' | 'GAS_PURCHASED_NM3' | 'GAS_PURCHASED_KWH' | 'GAS_SOLD_NM3' | 'GAS_SOLD_VARIATION' | 'RATIO_CONSUMPTION_KWH_GAS_PURCHASED_NM3' | 'RATIO_GAS_SOLD_PERCENT' | 'SUB_PURCHASED_SOLD_NM3' | 'PTA_MIN' | 'PTA_MAX' | 'PTA_AVG' | 'COS_PHI_AVG';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search kpi
     */
    body?: any
}

export function getPerfEnergyKpIsGroupByStation$Any(http: HttpClient, rootUrl: string, params?: GetPerfEnergyKpIsGroupByStation$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PerfEnergyStationKpiPagedList>> {
  const rb = new RequestBuilder(rootUrl, getPerfEnergyKpIsGroupByStation$Any.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PerfEnergyStationKpiPagedList>;
    })
  );
}

getPerfEnergyKpIsGroupByStation$Any.PATH = '/custom/kpi/perf-energy/group-by-station/search';
